<template>
  <div class="st-spinner">
    <div
      class="spinner"
      :aria-label="isStoryBook ? 'Spinner alt text' : ariaLabel"
      :class="variations"
    ></div>
    <div class="message" v-if="loadingMessage" aria-live="assertive">{{ loadingMessage }}</div>
  </div>
</template>

<script>
export default {
  computed: {
    isStoryBook() {
      return process.env.STORYBOOK_SELF;
    },
    variations() {
      return [this.thin && "thin", this.small && "small"];
    },
  },
  props: {
    isLoading: {
      type: Boolean,
      default: false,
    },
    loadingMessage: {
      type: String,
      default: "",
    },
    thin: {
      type: Boolean,
      default: false,
    },
    small: {
      type: Boolean,
      default: false,
    },
    ariaLabel: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../scss/main.scss";

.st-spinner {
  display: flex;
  flex-direction: column;
  align-items: center;
  .spinner {
    border-top: 0.16em solid #e5e5e5;
    border-right: 0.16em solid #e5e5e5;
    border-bottom: 0.16em solid #e5e5e5;
    border-left: 0.16em solid #ccc;
    width: 1.52em;
    height: 1.52em;
    &.thin {
      border: 0.04em solid $vit;
      border-top: 0.04em solid rgba(77, 72, 69, 0.24);
      border-right: 0.04em solid rgba(77, 72, 69, 0.24);
      width: 1.28em;
      height: 1.28em;
    }
    &.small {
      border: 0.04em solid $vit;
      border-top: 0.04em solid rgba(77, 72, 69, 0.24);
      border-right: 0.04em solid rgba(77, 72, 69, 0.24);
      width: 0.4em;
      height: 0.4em;
    }
    border-radius: 50%;
    animation: spin 1s linear infinite;
    font-size: 3.125em;
    transform: translate(-50%, -50%);
    -ms-transform: translate(-50%, -50%);
  }

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }

  .message {
    margin-top: 1em;
    font-size: 1em;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    letter-spacing: normal;
    color: #6e6054;
  }
}
</style>
